import { modalController, ModalOptions } from '@ionic/core';

import { Components } from '../../../components';
import { canDismiss } from '../../../global/ion-utils';

export async function presentOpenAppPrompt(operatingSystem: 'ios' | 'android') {
  const componentProps: Components.OgOpenAppPrompt = {
    operatingSystem,
  };
  const modalOptions: ModalOptions = {
    cssClass: 'open-app-prompt',
    component: 'og-open-app-prompt',
    backdropDismiss: false,
    canDismiss,
    componentProps,
    animated: true,
  };
  const modal = await modalController.create(modalOptions);
  await modal.present();
}
